module.exports = "<symbol id=\"tt-icon-arrow-fill\" viewBox=\"0 0 24 24\"><path d=\"M0 6.09C3.9 10 8.1 14 12 17.91 16.1 14 19.9 10 24 6.09z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/v6J5ZUpvDmQ7AMLsite/assets/svg/comments-pinboard-page/arrow-fill.svg
// module id = 175
// module chunks = 11